module.exports = __webpack_public_path__ + "2f0da2a4fa45a0b7d61e379bcc51d5c2.jpg";